import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { companySettingsQuery } from '@/queries/company.settings.query'

// L'accès OuiSense est déjà garanti par le layout /_dashboard/admin (isOuisenseUser -> notFound).
export const Route = createFileRoute('/_dashboard/admin/sidebar-sections/')({
  loader({ context }) {
    return context.queryClient.ensureQueryData(companySettingsQuery())
  },
  pendingComponent: PendingComponent,
})
